import Loader from "@/components/Common/kpi/Loader";
import {type FC} from "react";

const FullPageLoader: FC = () => {
  return (
    <Loader
      styles={{
        containerClassName: "h-[90vh] w-full items-center",
        loaderClassName: "h-20 w-20",
      }}
    />
  );
};

export default FullPageLoader;
